import React from "react";

import { faAngleLeft, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./Header.module.scss";

const messages = defineMessages({
  pickDateAndTime: {
    id: "email.emailScheduleSendPopover.pickDateAndTime",
    defaultMessage: "Pick a date & time",
    description: "Schedule send custom date view title",
  },
  scheduleSend: {
    id: "email.emailScheduleSendPopover.scheduleSend",
    defaultMessage: "Schedule send",
    description: "Schedule send popover title",
  },
});

export interface HeaderProps {
  isCustom: boolean;
  onChangeCustom: (value: boolean) => void;
  onClose: () => void;
  timezoneDisplayName: string;
}

const Header = ({ isCustom, onChangeCustom, onClose, timezoneDisplayName }: HeaderProps) => {
  const intl = useIntl();

  return (
    <div className={styles.header}>
      {isCustom && (
        <Button
          className={styles.backButton}
          icon={<FontAwesomeIcon icon={faAngleLeft} />}
          onClick={() => onChangeCustom(false)}
          size="small"
          type="control"
        />
      )}
      <div className={styles.headerText}>
        <span className={styles.title}>
          {isCustom
            ? intl.formatMessage(messages.pickDateAndTime)
            : intl.formatMessage(messages.scheduleSend)}
        </span>
        <span className={styles.subtitle}>{timezoneDisplayName}</span>
      </div>
      <Button
        className={styles.closeButton}
        icon={<FontAwesomeIcon icon={faTimes} />}
        onClick={onClose}
        size="small"
        type="control"
      />
    </div>
  );
};

export default Header;
